import { render } from "./ReservasConsumos.vue?vue&type=template&id=06bda5b2&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"servicios\":\"data\",\"consultarConsumos\":\"options\"}"
import script from "./ReservasConsumos.vue?vue&type=script&lang=js"
export * from "./ReservasConsumos.vue?vue&type=script&lang=js"

import "./ReservasConsumos.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script